import { CSSProperties, FC } from 'react';

import { Box } from '@mantine/core';

import { Component } from 'models';
import { ComponentImageHelpers } from 'helpers/ComponentImageHelpers';

import { ComponentIcon } from 'components/component-icons/ComponentIcon';
import { useFile } from 'hooks/use-file';

import { Thumbnail } from './Thumbnail';

const ComponentThumbnail: FC<{
    component: Pick<Component, 'type' | 'images'> | undefined;
    style?: CSSProperties;
    showEmpty?: boolean;
    fallbackSize?: number;
}> = ({ component, style, showEmpty, fallbackSize: incomingFallbackSize }) => {
    const { file, isLoading } = useFile(ComponentImageHelpers.thumbnail(component?.images)?.file);

    const fallbackSize =
        incomingFallbackSize || (style?.width && typeof style.width === 'number' ? style.width / 2 : 50);

    return component?.type ? (
        <Thumbnail
            image={file}
            isLoading={isLoading}
            style={style}
            showEmpty={showEmpty}
            fallback={
                <Box w={fallbackSize}>
                    <ComponentIcon type={component.type} />
                </Box>
            }
        />
    ) : null;
};

export { ComponentThumbnail };
